// import { Box, Divider, Typography ,styled} from "@mui/material";
// import { Link, Links } from "react-router-dom";
// import InstagramIcon from "@mui/icons-material/Instagram";

// const CustomeColor = styled(Box)(({ theme }) => ({
//   background: `linear-gradient(60deg,${theme.palette.primary.main},${theme.palette.secondary.main})`,
//   height: "230px",
//   padding: "10px",
//   marginTop: "10px",
//   display: "flex",
//   flexDirection: "column",
//   justifyContent: "space-around",
//   borderTopLeftRadius: "10px",
//   borderTopRightRadius: "10px",
// }));
// const Footer = () => {
//   return (
//     <CustomeColor>
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "space-evenly",
//           alignItems: "center",
//         }}
//       >
//         <Typography
//           component={Link}
//           to={"/aboutus"}
//           variant="body2"
//           sx={{ textDecoration: "none", color: "white" }}
//         >
//           About Us
//         </Typography>
//         <Typography
//           component={Link}
//           to={"/contactus"}
//           variant="body2"
//           sx={{ textDecoration: "none", color: "white" }}
//         >
//           Contact Us
//         </Typography>
//         <Typography
//           component={Link}
//           to={"/aboutus"}
//           variant="body2"
//           sx={{ textDecoration: "none", color: "white" }}
//         >
//           Site Map
//         </Typography>
//       </Box>
//       <Divider variant="fullwidth" sx={{ color: "white" }} />

//       <Box
//         sx={{
//           display: "flex",
//           width: "100%",
//           justifyContent: "space-around",
//           alignItems: "center",
//           color:'white'
//         }}
//       >
//             <Box sx={{display:'inline-flex',alignItems:'center','gap':'2px'}}>

//             <InstagramIcon
//               fontSize="1.5rem"
//               sx={{ width: "2rem", height: "2rem" }}
//               />
//             <Typography variant="body1" textAlign={"center"}>Instagrm ID          </Typography>
//               </Box>
//            <Link to="https://www.instagram.com/cosmeticompare/#" target="_blank" style={{
//     textdecoration: "none",
//     color: "white",
//     float: "right",
//     fontStyle: "italic",
//     fontWeight: "bold",
//     letterSpacing: "1px",
// }}>
//              @cosmeticompare
//               </Link>
          

       
//       </Box>

//       <Box sx={{ alignSelf: "center" ,color:'white' }}>
//         <Typography variant="body2">@ Copyrigth 2025 CosmetixHub</Typography>
//       </Box>
//       <Box sx={{ alignSelf: "center" ,color:'white' }}>
//         <Typography variant="body2" component={Link}
//           to={"/privacy-policy"} sx={{ textDecoration: "none", color: "white" }}>
//           Privacy Policy
//         </Typography>
//         <Typography variant="body2" component={Link}
//           to={"/terms"} sx={{ textDecoration: "none", color: "white" }}>
//          - Terms & Condition
//         </Typography>
//       </Box>
//     </CustomeColor>
//   );
// };

// export default Footer;

import {
  Box,
  Container,
  Grid,
  IconButton,
  Link as MuiLink,
  Stack,
  Typography,
} from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import CloseIcon from '@mui/icons-material/Close';
import LOGO from "../assets/icons/logo.svg";
import { useNavigate, Link as RouterLink } from "react-router-dom";
const Footer = () => {
  const menuLinks = [
    { label: 'Home', path: '/' },
    { label: 'About us', path: '/aboutus' },
    { label: 'Blogs', path: '/blog/' },
    { label: 'Contact us', path: '/contactus' },
  ];
  const productLinks = [
    { label: 'Sunscreen', path: '/category?main=skin%20care&sub=Sunscreen' },
    { label: 'Brush', path: '/category?main=hair%20styling&sub=Hair%20Brushes' },
    { label: 'Concealer', path: '/category?main=beauty&sub=Concealer' },
    { label: 'Contour', path: '/category?main=beauty&sub=Contour' },
    { label: 'Eye Shadow', path: '/category?main=beauty&sub=Eye%20Shadow' },
    { label: 'Highlighter', path: '/category?main=beauty&sub=Highlighter' },
    { label: 'Brow', path: '/category?main=beauty&sub=Brow' },
  ];
  const legalLinks = [
    { label: 'Privacy Policy', path: '/privacy-policy' },
    { label: 'Terms & Conditions', path: '/terms' },
    { label: 'Data Deletion', path: '/contactus' },
  ];
  const navigate = useNavigate();
  return (
    <Box
      component="footer"
      sx={{
        marginTop:'10px',
        position: 'relative',
        overflow: 'hidden',
        background:'black',
        color: '#fff',
        borderTop: '1px solid rgba(255,255,255,0.05)',
      }}
    >
      <Container
        maxWidth="xl"
        sx={{
          position: 'relative',
          zIndex: 2,
          px: { xs: 2, sm: 3, md: 4, lg: 6 },
          pt: { xs: 4, sm: 5, md: 6, lg: 7 },
          pb: { xs: 10, sm: 11, md: 13, lg: 16 },
        }}
      >
        <Grid
          container
          columnSpacing={{ xs: 4, sm: 5, md: 10, lg: 30 }}
          rowSpacing={{ xs: 4, sm: 5, md: 4 }}
        >
          {/* Left content */}
          <Grid item xs={12} md={5} lg={4.5}>
            <Box sx={{ maxWidth: { xs: '100%', md: 340, lg: 360 } }}>
              <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          width: 80,
                          height: 80,
                          ml: { xs: 1.5, sm: 3 },
                        }}
                      >
                        <Box
                          component="img"
                          src={LOGO}
                          onClick={() => {
                            navigate("");
                          }}
                          alt="CosmetixHub logo"
                          sx={{
                            width: 80,
                            height: 80,
                            objectFit: "contain",
                            cursor: "pointer",
                          }}
                        />
                      </Box>

              <Typography
                sx={{
                  color: 'rgba(255,255,255,0.82)',
                  fontSize: { xs: '1rem', sm: '1rem', md: '1rem' },
                  lineHeight: { xs: 1.7, sm: 1.75, md: 1.8 },
                  mb: 2.5,
                  maxWidth: 340,
                }}
              >
                We help you discover beauty products with clarity and confidence—
                comparing across brands, prices, and ingredients, with a touch of
                luxury in every interaction.
              </Typography>

              <Stack direction="row" spacing={1}>
                <IconButton
                  sx={{
                    p: 0,
                    width: 24,
                    height: 24,
                    color: '#fff',
                  }}
                >
                  <InstagramIcon sx={{ fontSize: 22 }} />
                </IconButton>
                <IconButton
                  sx={{
                    p: 0,
                    width: 24,
                    height: 24,
                    color: '#1877F2',
                  }}
                >
                  <FacebookIcon sx={{ fontSize: 22 }} />
                </IconButton>
                <IconButton
                  sx={{
                    p: 0,
                    width: 24,
                    height: 24,
                    color: '#0A66C2',
                  }}
                >
                  <LinkedInIcon sx={{ fontSize: 22 }} />
                </IconButton>
                <IconButton
                  sx={{
                    p: 0,
                    width: 24,
                    height: 24,
                    color: '#fff',
                  }}
                >
                  <CloseIcon sx={{ fontSize: 20 }} />
                </IconButton>
              </Stack>
            </Box>
          </Grid>

          {/* Right columns */}
          <Grid item xs={12} md={7} lg={7.5}>
            <Grid
              container
              columnSpacing={{ xs: 12, sm: 5, md: 4, lg: 8 }}
              rowSpacing={{ xs: 4, sm: 4, md: 0 }}
            >
              <Grid item xs={6} sm={4}>
                <Typography
                  sx={{
                    fontSize: { xs: '1.55rem', sm: '1.6rem', md: '1.55rem' },
                    fontWeight: 700,
                    mb: 2,
                  }}
                >
                  Menu
                </Typography>

                <Stack spacing={1.3}>
                  {menuLinks.map((item, index) => (
                    <MuiLink
                      key={item.label}
                      component={RouterLink}
                      to={item.path}
                      target={item.label ==='Blog'? '_blank':''}
                      
                      underline="none"
                      sx={{
                        color:
                          index === 0 ? '#ff4fa3' : 'rgba(255,255,255,0.78)',
                        fontSize: { xs: '1rem', sm: '1rem', md: '1rem' },
                        fontWeight: index === 0 ? 600 : 400,
                        transition: '0.2s ease',
                        '&:hover': {
                          color: '#ff4fa3',
                        },
                      }}
                    >
                      {item.label}
                    </MuiLink>
                  ))}
                </Stack>
              </Grid>

              <Grid item xs={6} sm={4}>
                <Typography
                  sx={{
                    fontSize: { xs: '1.55rem', sm: '1.6rem', md: '1.55rem' },
                    fontWeight: 700,
                    mb: 2,
                  }}
                >
                  Products
                </Typography>

                <Stack spacing={1.3}>
                  {productLinks.map((item) => (
                    <MuiLink
                      key={item.label}
                      component={RouterLink}
                      to={item.path}
                      underline="none"
                      sx={{
                        color: 'rgba(255,255,255,0.78)',
                        fontSize: { xs: '1rem', sm: '1rem', md: '1rem' },
                        transition: '0.2s ease',
                        '&:hover': {
                          color: '#ff4fa3',
                        },
                      }}
                    >
                      {item.label}
                    </MuiLink>
                  ))}
                </Stack>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Typography
                  sx={{
                    fontSize: { xs: '1.55rem', sm: '1.6rem', md: '1.55rem' },
                    fontWeight: 700,
                    mb: 2,
                    mt: { xs: 0, sm: 0, md: 0 },
                  }}
                >
                  Legal
                </Typography>

                <Stack spacing={1.3}>
                  {legalLinks.map((item) => (
                    <MuiLink
                      key={item.label}
                      component={RouterLink}
                      to={item.path}
                      underline="none"
                      sx={{
                        color: 'rgba(255,255,255,0.78)',
                        fontSize: { xs: '1rem', sm: '1rem', md: '1rem' },
                        transition: '0.2s ease',
                        '&:hover': {
                          color: '#ff4fa3',
                        },
                      }}
                    >
                      {item.label}
                    </MuiLink>
                  ))}
                </Stack>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>

      {/* Big background brand text */}
      <Box
        sx={{
          position: 'absolute',
          left: { xs: 0, sm: 8, md: 10, lg: 0 },
          right: 0,
          bottom: { xs: 22, sm: 18, md: 8, lg: -8 },
          zIndex: 1,
          pointerEvents: 'none',
          userSelect: 'none',
          overflow: 'hidden',
        }}
      >
        <Typography
          sx={{
            fontSize: {
              xs: '3rem',
              sm: '3rem',
              md: '7rem',
              lg: '9.5rem',
              xl: '11rem',
            },
            lineHeight: 0.85,
            fontWeight: 900,
            letterSpacing: {xs:'1px',md:'5px'},
            whiteSpace: 'nowrap',
            background: 'linear-gradient(180deg, #d85aa5 0%, #8a2d63 55%, #26101b 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            opacity: 0.95,
          }}
        >
          Cosmeticompare
        </Typography>
      </Box>

      {/* Copyright */}
      <Box
        sx={{
          position: 'absolute',
          left: 0,
          right: 0,
          bottom: { xs: 8, sm: 10, md: 12, lg: 14 },
          zIndex: 3,
          textAlign: 'center',
          px: 2,
        }}
      >
        <Typography
          sx={{
            color: 'rgba(255,255,255,0.68)',
            fontSize: { xs: '0.9rem', sm: '0.95rem', md: '0.95rem' },
          }}
        >
          Copyright © 2026 CosmetiCompare. All rights reserved
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;